import { S3Client } from '@aws-sdk/client-s3'
import { getSignedUrl } from '@aws-sdk/s3-request-presigner'
import { APIGatewayEvent } from 'aws-lambda'
import DataLoader from 'dataloader'
import myzod, { Infer } from 'myzod'
import { EmailSchema, UserRoles } from '../user/user'
import {
  GetIq11TokenInfoKey,
  Iq11TokenInfoResultWithDbId,
} from '../vopay/types'

export const sessionSchema = myzod.object({
  cognitoUsername: myzod.string(),
  owner: EmailSchema,
  userId: myzod.string().pattern(/^User#/),
  roles: myzod.array(myzod.enum(UserRoles)),
})

export type Session = Infer<typeof sessionSchema>

export interface Dataloaders {
  bankAccounts: DataLoader<GetIq11TokenInfoKey, Iq11TokenInfoResultWithDbId>
}

export interface Clients {
  s3: S3Client
  getSignedUrl: typeof getSignedUrl
}

export interface Context {
  session: Session
  dataloaders: Dataloaders
  clients: Clients
}

export const extractClaims = (event: APIGatewayEvent): Session => {
  const claims = event.requestContext.authorizer?.claims

  let user: any = {}
  if (event.requestContext.authorizer?.claims?.user) {
    user = JSON.parse(event.requestContext.authorizer?.claims?.user)
  }

  return sessionSchema.parse({
    cognitoUsername: claims.sub,
    owner: claims.email,
    userId: user?.id || 'User#Undefined',
    roles: user?.roles || [],
  })
}

export const hasRole = (role: UserRoles, session: Session) => {
  return session.roles ? session.roles.includes(role) : false
}
